import { render, staticRenderFns } from "./setting-company-branch-office.vue?vue&type=template&id=511f7b02&"
import script from "./setting-company-branch-office.vue?vue&type=script&lang=js&"
export * from "./setting-company-branch-office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports